var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"icon-download",class:_vm.className,attrs:{"href":_vm.url,"download":""}},[_c('img',{attrs:{"src":require(("../../../assets/img/icons/" + _vm.icon)),"alt":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }